import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';

export default class BulkDeleteModal extends React.Component {
  static propTypes = {
    entityCount: PropTypes.number,
    entityName: PropTypes.string,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    const {
      entityCount,
      entityName,
      shown,
      onCancel,
      onDelete
    } = this.props;

    return (
      <Modal show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Bulk Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body className="left-buffer-md">
          <div className="bottom-buffer-sm">You are about to delete <strong>{entityCount} {entityName}</strong></div>
          <div className="top-buffer-sm">
            This action is permanent. If this contact is associated with a voucher,
            a copy will remain attached to the voucher but will not be editable.
            Are you sure you want to delete?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-sm btn-cancel" onClick={onCancel}>Cancel</button>
          <button className="btn btn-sm btn-danger" onClick={onDelete}>Delete {entityName}</button>
        </Modal.Footer>
      </Modal>
    );
  }
}
